export default "__VITE_ASSET__BnskFiKf__"